export const MEMBER_STATUS = {
  ACTIVE: "ACTIVE",
  SUSPENSION: "SUSPENSION"
};

export const ADMIN_ROLE = {
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN"
};